import BasicLayout from "../../layout/curr.vue"
// const pre = ' - 极客轻商城系统';
const meta = {
  auth: true
};

export default {
  path: 'sales',
  name: 'sales',
  component: BasicLayout,
  children: [{
      path: 'discount',
      name: "sales-discount",
      component: () => import("@/pages/admin/sales/discount.vue"),
      meta: {
        ...meta,
        title: '折扣管理 - 极客商城系统'
      }
    },
    {
      path: "*",
      redirect: '/home'
    },
    // {
    //   path: 'coupon',
    //   name: "sales-coupon",
    //   component: () => import("@/pages/admin/sales/coupon.vue"),
    //   meta: { title: '优惠券管理 - 极客商城系统' }
    // }

  ]
};